import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import studygameActions from '../../store/actions/studygameActions'
import Loading from '../Loading'
import NewsGame from './NewsGame'
import GameButtons from './GameButtons'

/* const calculateRandom = (min, max) => {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min)) + min
} */

const shuffler = (array) => {
    return array.sort(() => Math.random() - 0.5)
}

const GuessImage = ({ news }) => {
    const [state, setState] = useState({
        imgs: [
            { src: news.image, isRight: true, alt: 'Photo' }
        ],
        imagesToGet: 3,
        didAnswer: false,
        answerNumber: null
    })

    useEffect(() => {
        const imgsState = state.imgs
        const newsIndex = allNews.findIndex(article => article.image === news.image)
        var falseImgIndex = []

        //generate random unique numbers
        while (falseImgIndex.length < state.imagesToGet) {
            var r = Math.floor(Math.random() * allNews.length - 1) + 1;
            if (falseImgIndex.indexOf(r) === -1 && r !== newsIndex) falseImgIndex.push(r);
        }

        falseImgIndex.forEach((item) => {
            imgsState.push({ src: allNews[item].image, isRight: false, alt: allNews[item].title })
        })

        setState({ ...state, titles: shuffler(imgsState) })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAnswer = (answer, index) => {
        setState({
            ...state,
            didAnswer: true,
            answerNumber: index
        })

        setTimeout(() => {
            if (answer) {
                dispatch(studygameActions.finishMinigame())
            } else {
                setState({ ...state })
            }
        }, 1000)
    }

    const dispatch = useDispatch()
    const allNews = useSelector(state => state.studyGame.news)
    const isLoading = useSelector(state => state.studyGame.isLoading)
    const disabledImg = state.didAnswer ? true : false
    const { answerNumber, imgs } = state
    const newsObject = { ...news, image: true }

    const studyGameState = useSelector(state => state.studyGame)
    const { currentRound } = studyGameState

    return (
        isLoading ? <Loading /> :
            <article className='white-container mb-4'>
                <NewsGame round={currentRound} news={newsObject} gameTitle='Selecione a imagem correta da notícia!' />
                <div className='grid grid-cols-1 md:grid-cols-2 gap-8 py-8 md:py-10'>
                    {imgs.map((item, index) =>
                        <div key={index} className='object-contain relative'>
                            <img
                                src={item.src}
                                alt={item.alt}
                                title={item.alt}
                                className={`img-guess block`}
                            />
                            <div key={item} className={`img-guess overlayText ${(disabledImg && answerNumber === index) && item.isRight ? "img-success" : (disabledImg && answerNumber === index) && "img-error"}`} onClick={() => !disabledImg && handleAnswer(item.isRight, index)}>
                                <h3 className='textOverlay'>Imagem {!item.isRight ? `incorreta` : `correta`}</h3>
                            </div>
                        </div>
                    )}
                </div>
                <GameButtons />
            </article>
    )
}

export default GuessImage